import {
  createContext,
  FC,
  PropsWithChildren,
  useEffect,
  useState,
} from 'react';

import getStringifiedObject from '@bluecodecom/utils/getStringifiedObject';

import { nativeService } from '../../service';
import {
  VasHostConfig,
  VasHostConfigContextValue,
} from './VasHostConfig.types';

export const VasHostConfigContext =
  createContext<VasHostConfigContextValue | null>(null);

const VasHostConfigProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<VasHostConfig>({
    currentLanguage: 'DE',
    hasSuggestionsEnabled: false,
    isDarkThemeEnabled: false,
    isLocationAccepted: false,
    isLocationEnabled: false,
    isPushNotificationAccepted: false,
    isSuggestionsTabEnabled: false,
    hasNfcPaymentActivated: false,
    isVasEnabled: false,
    sdkSessionId: null,
  });

  useEffect(() => {
    window.setVasHostConfig = (payload: string) => {
      const data = getStringifiedObject(payload) as Partial<VasHostConfig>;

      setData((d) => ({
        ...d,
        ...data,
        // The SDK telemetry session id, registered downstream as the
        // `session_id` analytics super property. Normalised because the host
        // sends `''` before a session exists and SDK builds older than the one
        // that added the field omit it entirely — neither may leak into the
        // context, and a later payload without it must not wipe a known id.
        sdkSessionId: data.sdkSessionId || d.sdkSessionId || null,
      }));

      setIsLoading(false);
    };

    nativeService.requestVasHostConfig();
  }, []);

  return (
    <VasHostConfigContext.Provider value={{ isLoading, ...data }}>
      {children}
    </VasHostConfigContext.Provider>
  );
};

export default VasHostConfigProvider;
